export default __webpack_public_path__ + "static/media/Megamart.30e284f0.jpeg";